module.exports = __webpack_public_path__ + "static/img/banner_f.f72ef4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_f.jpg
// module id = WbJG
// module chunks = 1